import { api } from '@/api/client';

export const projectsApi = {
  // WEB-329: optional orgId scopes the result to that organization.
  list: (orgId?: string) =>
    api.get('/projects', orgId ? { params: { orgId } } : undefined),
  create: (data: Record<string, unknown>) => api.post('/projects', data),
  get: (id: string) => api.get(`/projects/${id}`),
  update: (id: string, data: Record<string, unknown>) =>
    api.patch(`/projects/${id}`, data),
  // WEB-341: safeguard delete (P2 §F10) — re-auth + type-to-confirm.
  // BE: DELETE /projects/:id with body {confirmName, password}.
  delete: (id: string, dto: { confirmName: string; password: string }) =>
    api.delete(`/projects/${id}`, { data: dto }),
  // WEB-760: каскад-счётчики для опасной зоны/модалки удаления.
  deletePreview: (id: string) => api.get(`/projects/${id}/delete-preview`),
};
